'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.js');
var ResizeObserver_es = require('../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js');

function _interopNamespaceDefaultOnly (e) { return { __proto__: null, 'default': e }; }

var ResizeObserver_es__namespace = /*#__PURE__*/_interopNamespaceDefaultOnly(ResizeObserver_es);

var require$$9 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(ResizeObserver_es__namespace);

module.exports = require$$9;
